import { useEffect } from 'react';

interface LoginLoadingProps {
  onLoadingComplete?: () => void;
}

export function LoginLoading({ onLoadingComplete }: LoginLoadingProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      if (onLoadingComplete) {
        onLoadingComplete();
      }
    }, 3000); // 3 segundos de carregamento

    return () => clearTimeout(timer);
  }, [onLoadingComplete]);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-linear-to-br from-[#9ebe3b] via-[#7da32e] to-[#6b8e28] z-9999">
      <div className="flex flex-col items-center gap-8 animate-fade-in">
        {/* Spinner Container */}
        <div className="relative w-24 h-24">
          {/* Spinner externo */}
          <div className="absolute inset-0 border-8 border-white/20 rounded-full"></div>
          {/* Spinner animado */}
          <div className="absolute inset-0 border-8 border-transparent border-t-white rounded-full animate-spin"></div>
        </div>

        {/* Texto de carregamento */}
        <div className="text-center">
          <h2 className="text-2xl font-bold text-white mb-2 animate-pulse">Carregando...</h2>
          <p className="text-white/80 text-sm">Preparando o sistema para você</p>
        </div>
      </div>
    </div>
  );
}
